export const Tomorrow = () => {
  const tom = new Date();
  tom.setDate(tom.getDate() + 1);

  return tom;
};
